module.exports = __webpack_public_path__ + "8ede8506de9a606e3b8e8c53459248af.pdf";